import React, { useMemo } from "react";
import { Table } from "antd";
import classNames from "classnames";
import "./cfo.scss";

const months = ["1 Jan", "2 Jan", "3 Jan", "4 Jan", "5 Jan", "6 Jan"];

const generateColumns = () => [
  { title: "Type", dataIndex: "type", key: "type" },
  ...months.map((month) => ({
    title: month,
    dataIndex: month,
    key: month,
    render: (text: string, record: { isRed?: boolean }) => (
      <span style={{ color: record.isRed ? "#FF5C5C" : "#fff" }}>{text}</span>
    ),
  })),
];

interface Row {
  key: React.Key;
  type: string;
  isRed?: boolean;
  children?: Row[];
  [key: string]: any;
}

const flattenData = (data: unknown): Row[] =>
  Array.isArray(data)
    ? data.map((item: any) => {
        const row: Row = {
          key: item.key,
          type: item.type,
          isRed: item.isRed,
          ...(item.months || {}),
        };
        if (Array.isArray(item.children))
          row.children = flattenData(item.children);
        return row;
      })
    : [];

interface ExpandIconProps {
  expanded: boolean;
  onExpand: (record: any, e: React.MouseEvent<HTMLButtonElement>) => void;
  record: any;
}

const ExpandIcon: React.FC<ExpandIconProps> = ({
  expanded,
  onExpand,
  record,
}) =>
  record.children ? (
    <button
      type="button"
      className={classNames("ant-table-row-expand-icon", {
        "ant-table-row-expand-icon-collapsed": !expanded,
        "ant-table-row-expand-icon-expanded": expanded,
      })}
      aria-label="Expand row"
      aria-expanded={expanded}
      onClick={(e) => onExpand(record, e)}
    />
  ) : null;

interface CFOProps {
  data?: any[];
}

const CFO: React.FC<CFOProps> = ({ data = [] }) => {
  const tableData = useMemo(() => flattenData(data), [data]);

  return (
    <div className="cfoWrapper">
      <Table
        columns={generateColumns()}
        dataSource={tableData}
        pagination={false}
        expandable={{
          expandRowByClick: true,
          expandIcon: ExpandIcon,
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default CFO;
